var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.exportCSV()}}},[_vm._v("\n  Exportar CSV \n  "),_c('font-awesome-icon',{attrs:{"icon":'file-csv'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146ab6c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProcedimentosSaude/ExportCSV.vue
// module id = /LCp
// module chunks = 15